import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { ReportSectionHeader } from "../SectionHeader";


const SettlementRateComponent = (props) => (
	<div>
		<ReportSectionHeader>
			{!props.caseRuleTypeId || props.caseRuleTypeId === 3 ? "Section 11 " : "Rule 10b-5 "}
			 Empirical Settlement to Estimated Maximum Potential Damages Ratios
		</ReportSectionHeader>

		<ReportTable
			settings={
			[
				{
					header: `Estimated Maximum Potentially Available ${!props.caseRuleTypeId || props.caseRuleTypeId === 3 ? "Section 11 " : "Rule 10b-5 "} Aggregate Damages Band \n(000s)`,
					accessor: 'settlementRateBandLabel'
					
				},
				{
					header: 'Case Count Population',
					accessor: 'settlementRateBandCaseCount'
					
				},
				{
					header: 'Median Ratio',
					accessor: 'settlementRateValue',
					round2Decimal: true,
					percentageSign: true,
					percentageNumber: true,
					tooltip: `Median Settlement to Estimated Maximum Potentially Available ${!props.caseRuleTypeId || props.caseRuleTypeId === 3 ? "Section 11 " : "Rule 10b-5 "} Aggregate Damages`
				},
			]

			}
			data={props.currentSettlementRateBands}
			name={"currentSettlementRateBands"}

		/>
		<p />
		<div class="purchase-text">
		<div class="purchase-body">
		<div class="purchase-section">
		{!props.caseRuleTypeId || props.caseRuleTypeId !== 3 ?
			"Ratios are the medians of the quotients of Rule 10b-5  claims settlement amounts as reported by Institutional Shareholder Services SCAS (ISS SCAS) to SAR's estimates of maximum potentially available aggregate damages for the corresponding claims.  SAR's database of Rule 10b-5 Exchange Act claims against U.S. issuers of common stock covers claims originally filed in June of 2018 or thereafter and claims originally filed in January of 2020 or thereafter for claims against non-U.S. issuers.  Displayed median ratios are based on all available SCA claim data and are updated cumulatively on a quarterly basis, as more settlement data becomes available."
			:
			"The displayed ratio is the median of the quotient of all Section 11 claim settlement amounts as reported by Institutional Shareholder Services SCAS (ISS SCAS) to SAR's estimates of maximum potentially available aggregate damages for the corresponding claims. SAR's database of Section 11 Securities Act claims against U.S.-listed issuers of common stock or American depositary receipts covers claims originally filed in 2020 or thereafter. The displayed median ratio is based on all available SCA claim data and is updated cumulatively on a quarterly basis, as more settlement data becomes available."

		}
		
		</div>
		</div>
		</div>
	</div>
);


export default SettlementRateComponent;



// WEBPACK FOOTER //
// ./src/common/components/SettlementRate/SettlementRateComponent.js